export const readEmployeeVacationIntimations = (response: any) => {
  const envelope = response?.data?.success !== undefined ? response.data : response;
  if (envelope?.success === false) throw new Error(envelope.message || "Unable to load vacation intimations.");
  const data = [response?.data?.data, response?.data, response].find(value => Array.isArray(value?.items));
  if (!data) throw new Error("The vacation intimation response does not contain a request list.");
  return data;
};

export const findVacationIntimationIndex = (data: any, reference: string): number => {
  const items: any[] = data.items;
  const exact = items.findIndex(item => [item.vacationIntimationId, item.vacationId, item.id]
    .some(value => value != null && String(value) === reference));
  if (exact >= 0) return exact;
  const matches = items.map((item, index) => ({ item, index })).filter(({ item }) =>
    [item.allotmentReferenceNumber, item.registrationReferenceNumber].some(value => value != null && String(value) === reference));
  const latest = matches.find(({ item }) => String(item.vacationId ?? item.id) === String(data.lastRequest?.vacationId));
  return latest?.index ?? matches[0]?.index ?? 0;
};
